import * as types from './mutations-types';
import api from './api';

export default {
	async getPlants_({ commit }) {
		let data = await api.getPlants();
		let options = [];
		if (data.body) {
			data.body.map(v => {
				if (v.commCdName !== 'PLANT') {
					options.push({ text: v.commCdName, value: v.commCd });
				}
			});
		}
		return commit(types.DEFAULT_ASSIGN, {
			key: 'plants',
			value: options
		});
	},
	async getLoginHistoryList_({ commit }, { searchParams, currentPage, pageUnit }) {
		// console.log('@@@@ currentPage: ', currentPage);
		// console.log('@@@@ pageUnit: ', pageUnit);
		let data = await api.getLoginHistoryList({ searchParams, currentPage, pageUnit });
		// console.log('@@@@ data: ', data);

		if (data.header.code === 0) {
			let body = data.body.resultList;

			body.map((object, index) => {
				object.test = index;
			});
			commit(types.DEFAULT_ASSIGN, {
				key: 'resultList',
				value: body
			});
			commit(types.DEFAULT_ASSIGN, {
				key: 'groups',
				value: data.body.pagingInfo
			});
		}

		if (data.header.code === 1) {
		}
		if (data.header.code === 2) {
		}
		if (data.header.code === 3) {
			let body = data.body.resultList;

			body.map((object, index) => {
				object.test = index;
			});
			commit(types.DEFAULT_ASSIGN, {
				key: 'resultList',
				value: body
			});
			commit(types.DEFAULT_ASSIGN, {
				key: 'groups',
				value: data.body.pagingInfo
			});
		}
		if (data.header.code === 4) {
		}
		if (data.header.code === 5) {
		}

		if (data.header.code === 500) {
			// somethinig todo
		} else {
			// somethinig todo
		}

		return data.header;
	}
};
